// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cabe13a3","453":"95768e5f","455":"30aa6174"}[chunkId] + ".chunk.js";
};